export default "__VITE_ASSET__BnKqfvI7__"